import React from 'react'
import styled from 'react-emotion'
import { CONTRAST_COLOR } from '../constants'

export default ({ name }) => (
  <Container>
    <Avatar
      title={name}
      style={{
        background: `url('/assets/images/people/${name}.jpg') no-repeat center/contain`,
      }}>
      <Circle
        style={{ transform: `rotate(${Math.floor(Math.random() * 359)}deg)` }}
      />
    </Avatar>

    <Name>{name}</Name>
  </Container>
)

const Container = styled.div`
  display: inline-block;
  color: ${CONTRAST_COLOR};
  margin-bottom: 20px;
`

const Avatar = styled.div`
  display: inline-block;
  position: relative;
  background-color: transparent;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: 6px;
`

const Circle = styled.div`
  width: 38px;
  height: 38px;
  position: absolute;
  top: -4px;
  left: -4px;
  border-radius: 50%;
  border: 2px solid #fa1851;
  border-bottom-color: transparent;
  transform: rotate(10deg);
`

const Name = styled.div`
  margin-right: 40px;
  display: inline-block;
`
